// extracted by css-extract-rspack-plugin
export default {"root":"root-PlZp5o","sign":"sign-ZyBjwH","hideMobile":"hideMobile-iZDroQ","link":"link-TluuZx","label":"label-sPrH6h","phase":"phase-FKTxTR"};